<!--
<div [style.display]="'block'" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="card-header text-center">
                <div class="row">
                    <div class="col-md-12">
                        <img src="./assets/img/mykadainew.png" style="height:80px;width:80px;">
                    </div>
                </div>
            </div>
            <h5 class="text-center mt-3 font-weight-bold">REGISTER</h5>
            <div class="modal-body">
                <div style="border-color:#e9ecef #e9ecef #dee2e6 !important;padding: 10px;">
                    <form (ngSubmit)="onSubmit()" [formGroup]="shopOwnerDetails" id="shopOwnerDetails">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control text-capitalize" placeholder="First Name"
                                           id="firstName" formControlName="firstName">
                                    <span *ngIf="shopOwnerRegisterErrors.firstName"
                                          class="error-text">{{shopOwnerRegisterErrors.firstName}}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control text-capitalize" placeholder="Last Name"
                                           id="lastName"
                                           formControlName="lastName">
                                    <span *ngIf="shopOwnerRegisterErrors.lastName"
                                          class="error-text">{{shopOwnerRegisterErrors.lastName}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Email Address" id="emailId"
                                           formControlName="emailId">
                                    <span *ngIf="shopOwnerRegisterErrors.emailId"
                                          class="error-text">{{shopOwnerRegisterErrors.emailId}}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control"
                                           placeholder="Phone Number" id="phoneNumber" formControlName="phoneNumber"
                                           (keypress)="OnlyNumbers($event)" maxlength="10">
                                    <span *ngIf="shopOwnerRegisterErrors.phoneNumber"
                                          class="error-text">{{shopOwnerRegisterErrors.phoneNumber}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="User Name" id="userName"
                                           formControlName="userName" maxlength="20" autocomplete="new-userName">
                                    <span *ngIf="shopOwnerRegisterErrors.userName"
                                          class="error-text">{{shopOwnerRegisterErrors.userName}}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="password" class="form-control" [(ngModel)]="password"
                                           autocomplete="new-password"
                                           placeholder="Password" id="password" formControlName="password" minlength="8"
                                           maxlength="10">
                                    <i class="toggle-password fa fa-eye" data-toggle="tooltip" data-placement="top"
                                       title="Click to Show Password" (click)="togglePasswordVisibility()"
                                       [ngClass]="{'fa-eye-slash': isPasswordVisible, 'fa-eye': !isPasswordVisible}"
                                       aria-hidden="true"></i>
                                    <span *ngIf="shopOwnerRegisterErrors.password"
                                          class="error-text">{{shopOwnerRegisterErrors.password}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 form-group">
                            <input type="checkbox" id="enabled" formControlName="enabled">
                            <label class="ml-2"> I agree to the <a href="" data-toggle="modal" data-target="#myModal">Terms
                                &
                                Condition</a></label><br>
                            <span *ngIf="shopOwnerRegisterErrors.enabled"
                                  class="error-text">{{shopOwnerRegisterErrors.enabled}}</span>
                        </div>
                        <div class="text-center mt-1">
                            <button type="submit" class="btn btn-success font-weight-bolder btn-block mb-3">REGISTER
                            </button>
                        </div>
                    </form>
                    &lt;!&ndash; <div class="row">
                       <label class="text-align col-md-12 mt-3" type="button" (click)="onNavigation('login')">login</label>
                       </div> &ndash;&gt;
                    <p class="text-center text-muted mt-3 mb-0">Have already an account?
                        <a class="text-md-center font-weight-bold text-success" type="button" [routerLink]="['/']">Login
                            here</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>-->

<div class="register-container">
    <div class="left-panel d-none d-md-block">
        <div class="overlay">
            <h3 class="font-weight-bolder mb-3">Welcome</h3>
            <img src="assets/img/mykadainew.png" class="img-fluid register-logo" [routerLink]="['/']" type="button">
        </div>
    </div>
    <div class="right-panel">
        <form (ngSubmit)="onSubmit()" [formGroup]="shopOwnerDetails" id="shopOwnerDetails">
            <div class="text-center d-lg-none">
                <img src="assets/img/mykadainew.png" class="img-fluid" style="height: 100px" [routerLink]="['/']">
            </div>
            <h3 class="text-center mb-4">Register as shop</h3>
            <div class="form-floating mb-3">
                <input type="text" class="form-control" id="firstName" placeholder="First Name"
                       formControlName="firstName" [ngClass]="{
                 'is-invalid': shopOwnerDetails.get('firstName')?.invalid && shopOwnerDetails.get('firstName')?.touched,
                 'is-valid': shopOwnerDetails.get('firstName')?.valid && shopOwnerDetails.get('firstName')?.touched
               }">
                <label for="firstName">First Name</label>
                <span *ngIf="shopOwnerRegisterErrors.firstName"
                      class="error-text">{{ shopOwnerRegisterErrors.firstName }}</span>
            </div>

            <div class="form-floating mb-3">
                <input type="text" class="form-control" id="lastName" placeholder="Last Name"
                       formControlName="lastName" [ngClass]="{
                 'is-invalid': shopOwnerDetails.get('lastName')?.invalid && shopOwnerDetails.get('lastName')?.touched,
                 'is-valid': shopOwnerDetails.get('lastName')?.valid && shopOwnerDetails.get('lastName')?.touched
               }">
                <label for="lastName">Last Name</label>
                <span *ngIf="shopOwnerRegisterErrors.lastName"
                      class="error-text">{{ shopOwnerRegisterErrors.lastName }}</span>
            </div>

            <div class="form-floating mb-3">
                <input type="email" class="form-control" id="emailId" placeholder="Email Address"
                       formControlName="emailId" [ngClass]="{
                 'is-invalid': shopOwnerDetails.get('emailId')?.invalid && shopOwnerDetails.get('emailId')?.touched,
                 'is-valid': shopOwnerDetails.get('emailId')?.valid && shopOwnerDetails.get('emailId')?.touched
               }">
                <label for="emailId">Email Address</label>
                <span *ngIf="shopOwnerRegisterErrors.emailId"
                      class="error-text">{{ shopOwnerRegisterErrors.emailId }}</span>
            </div>

            <div class="form-floating mb-3">
                <input type="text" class="form-control" id="phoneNumber" placeholder="Phone Number"
                       formControlName="phoneNumber" (keypress)="OnlyNumbers($event)" maxlength="10" [ngClass]="{
                 'is-invalid': shopOwnerDetails.get('phoneNumber')?.invalid && shopOwnerDetails.get('phoneNumber')?.touched,
                 'is-valid': shopOwnerDetails.get('phoneNumber')?.valid && shopOwnerDetails.get('phoneNumber')?.touched
               }">
                <label for="phoneNumber">Phone Number</label>
                <span *ngIf="shopOwnerRegisterErrors.phoneNumber"
                      class="error-text">{{ shopOwnerRegisterErrors.phoneNumber }}</span>
            </div>

            <!--<div class="form-floating mb-3">
                <input type="text" class="form-control" id="userName" placeholder="User Name"
                       formControlName="userName" [ngClass]="{
                 'is-invalid': shopOwnerDetails.get('userName')?.invalid && shopOwnerDetails.get('userName')?.touched,
                 'is-valid': shopOwnerDetails.get('userName')?.valid && shopOwnerDetails.get('userName')?.touched
               }">
                <label for="userName">User Name</label>
                <span *ngIf="shopOwnerRegisterErrors.userName"
                      class="error-text">{{ shopOwnerRegisterErrors.userName }}</span>
            </div>-->

            <div class="form-floating mb-3 position-relative">
                <input [type]="isPasswordVisible ? 'text' : 'password'" class="form-control" id="password"
                       placeholder="Password" formControlName="password" [(ngModel)]="password" [ngClass]="{
                 'is-invalid': shopOwnerDetails.get('password')?.invalid && shopOwnerDetails.get('password')?.touched,
                 'is-valid': shopOwnerDetails.get('password')?.valid && shopOwnerDetails.get('password')?.touched
               }">
                <label for="password">Password</label>
                <i class="toggle-password fa"
                   [ngClass]="{'fa-eye': !isPasswordVisible, 'fa-eye-slash': isPasswordVisible}"
                   style="cursor:pointer;" (click)="togglePasswordVisibility()"></i>
            </div>
            <span *ngIf="shopOwnerRegisterErrors.password"
                  class="error-text">{{ shopOwnerRegisterErrors.password }}</span>

            <div class="form-check mb-3">
                <input type="checkbox" class="form-check-input" id="enabled" formControlName="enabled">
                <label class="form-check-label" for="enabled">
                    I agree to the <a [routerLink]="['/privacy-policy']" data-bs-toggle="modal" data-bs-target="#myModal">Terms & Conditions</a>
                </label>
                <span *ngIf="shopOwnerRegisterErrors.enabled"
                      class="error-text">{{ shopOwnerRegisterErrors.enabled }}</span>
            </div>

            <button type="submit" class="btn btn-success w-100">Register</button>

            <p class="text-center text-muted mt-3 mb-0">
                Already have an account?
                <a class="text-success fw-bold" [routerLink]="['/login']">Login</a>
            </p>
        </form>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>